export type ExtractedErrorDetails = {
    message: string
    name: string
    stack?: string
}

export type ExtractErrorDetailsOptions = {
    includeCause?: boolean
    maxStackLength?: number
}

function formatCause(cause: unknown): string | undefined {
    if (cause instanceof Error) {
        return cause.message
    }
    if (cause == null) {
        return undefined
    }
    if (typeof cause === 'object') {
        try {
            return JSON.stringify(cause)
        } catch {
            return String(cause)
        }
    }
    return String(cause)
}

export function extractErrorDetails(
    error: unknown,
    options: ExtractErrorDetailsOptions = {},
): ExtractedErrorDetails {
    const { includeCause = false, maxStackLength } = options

    if (error instanceof Error) {
        const causeMessage = includeCause ? formatCause(error.cause) : undefined
        const message = causeMessage ? `${error.message} | cause: ${causeMessage}` : error.message
        const stack =
            error.stack != null && maxStackLength != null
                ? error.stack.substring(0, maxStackLength)
                : error.stack

        return {
            message,
            name: error.name,
            ...(stack && { stack }),
        }
    }
    if (typeof error === 'string') {
        return { message: error, name: 'StringError' }
    }
    return { message: String(error), name: 'UnknownError' }
}
